import api from './api'

export const createPrivateMessage = async (ticketId, body) => {
  const { data } = await api.post(`/messages/${ticketId}/private`, { body })
  return data
}

export const updatePrivateMessage = async (messageId, body) => {
  const { data } = await api.put(`/messages/private/${messageId}`, { body })
  return data
}

export const deletePrivateMessage = async messageId => {
  await api.delete(`/messages/private/${messageId}`)
}
